import { render, staticRenderFns } from "./AddToSchedule.vue?vue&type=template&id=2b67c2e9"
import script from "./AddToSchedule.vue?vue&type=script&lang=js"
export * from "./AddToSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports